/** Englische Fassungen für den Bereich „publish" (Schlüssel = deutscher Satz). */
export const EN_PUBLISH: Record<string, string> = {
  'Wird neu gebaut. Das dauert meist ein, zwei Minuten.': 'Rebuilding. This usually takes a minute or two.',
  'Neu bauen ging nicht.': 'Rebuild failed.',
  'Erneut senden ging nicht.': 'Resend failed.',
  'Beitrag öffnen': 'Open post',
  'Wird gebaut…': 'Building…',
  'Die Bilder entstehen gerade.': 'The images are being created.',
  'Bilder fehlen': 'Images missing',
  'Noch kein Bild': 'No image yet',
  'Mit diesem Rezept gebaut': 'Built with this recipe',
  'Termin und Kanäle gespeichert.': 'Date and channels saved.',
  'Szene {n}: Bild fehlt': 'Scene {n}: image missing',
  'Bau fehlgeschlagen: Bilder fehlen': 'Build failed: images missing',
  'Nur {kanal} neu senden': 'Resend {kanal} only',
  'Erneut senden': 'Send again',
  'Die Bilder entstehen gerade. Die Ansicht aktualisiert sich von selbst.': 'The images are being created. This view updates by itself.',
  'Hängt? Neu bauen': 'Stuck? Rebuild',
  'Diesem Beitrag fehlen Bilder. Ohne sie lässt er sich nicht freigeben.': 'This post is missing images. It can\'t be approved without them.',
  'Fehlende Bilder erzeugen': 'Create missing images',
  'Noch kein Kanal gewählt.': 'No channel selected yet.',
  'Termin und Kanäle': 'Date and channels',
  'Ein Bildpost darf keine Videoszene enthalten.': 'An image post can\'t contain a video scene.',
  'Termin und Kanäle speichern': 'Save date and channels',
  'Zurücksetzen': 'Reset',
  'Format, Szenen und Musik änderst du im Story Builder.': 'Change format, scenes and music in the Story Builder.',
  'Erst die fehlenden Bilder erzeugen.': 'Create the missing images first.',
  'Diesen Beitrag verwerfen?': 'Discard this post?',
  'Er verschwindet aus Kalender und Liste. Verbrauchte Credits kommen nicht zurück.': 'It disappears from the calendar and the list. Credits already spent are not refunded.',
  '{n} Beiträge freigegeben.': '{n} posts approved.',
  '{n} Beitrag gelöscht.': '{n} post deleted.',
  '{n} Beiträge gelöscht.': '{n} posts deleted.',
  '{n} Beiträge werden neu gebaut.': '{n} posts are being rebuilt.',
  'Woche {range}': 'Week {range}',
  'Was wartet, was geplant ist und was schon draußen ist – an einem Ort.': 'What\'s waiting, what\'s scheduled and what\'s already out – in one place.',
  '+ Neuer Beitrag': '+ New post',
  'Schlägt ein Kanal fehl, bleibt der Erfolg auf dem anderen bestehen. Du sendest nur den fehlenden neu. Fehlen einem Beitrag Bilder, baust du ihn mit „Neu bauen" nach.': 'If one channel fails, the success on the other one stays. You only resend the missing one. If a post is missing images, use “Rebuild” to create them.',
  '1 Beitrag ist fehlgeschlagen': '1 post failed',
  '{n} Beiträge sind fehlgeschlagen': '{n} posts failed',
  'Anzeigen': 'Show',
  '{n} davon fehlen Bilder. Öffne sie und wähle „Neu bauen" – der Grund steht jeweils dabei.': '{n} of them are missing images. Open them and choose “Rebuild” – the reason is shown on each.',
  'Der Grund steht am Beitrag. „Erneut senden" überspringt Kanäle, auf denen er schon erschienen ist.': 'The reason is shown on the post. “Send again” skips channels where it has already been published.',
  'Erst nach deiner Freigabe landen sie im Kalender und gehen raus.': 'Only after your approval do they land in the calendar and go out.',
  'Vorherige Woche': 'Previous week',
  'Nächste Woche': 'Next week',
  'Heute': 'Today',
  'Alle Beiträge': 'All posts',
  'Ansicht': 'View',
  'Woche': 'Week',
  'Liste': 'List',
  'In dieser Woche ist nichts geplant.': 'Nothing is scheduled this week.',
  'Alle Beiträge als Liste': 'All posts as a list',
  '1 Beitrag hat noch keinen Termin.': '1 post has no date yet.',
  '{n} Beiträge haben noch keinen Termin.': '{n} posts have no date yet.',
  'In der Liste zeigen': 'Show in list',
  'Noch keine Beiträge': 'No posts yet',
  'Lass den Agenten Beiträge bauen oder leg selbst einen an. Fertige Beiträge erscheinen hier und im Kalender.': 'Let the agent build posts or create one yourself. Finished posts appear here and in the calendar.',
  'Wechsle den Filter, um andere Beiträge zu sehen.': 'Change the filter to see other posts.',
  'Zu den Rezepten': 'Go to recipes',
  'Selbst einen bauen': 'Build one yourself',
  '{n} neu bauen': 'Rebuild {n}',
  'Kommend und in Arbeit': 'Upcoming and in progress',
  '{n} Beitrag löschen?': 'Delete {n} post?',
  '{n} Beiträge löschen?': 'Delete {n} posts?',
  '{n} Beiträge freigeben?': 'Approve {n} posts?',
  'Alle offenen Beiträge von': 'All open posts of',
  'Szenen, Textzeilen, Bilder und Musik eines einzelnen Beitrags. Hier machst du von Hand, was der Agent sonst automatisch tut.': 'Scenes, text lines, images and music of a single post. Here you do by hand what the agent otherwise does automatically.',
  'Kein Beitrag in Arbeit': 'No post in progress',
  'Leg selbst einen an und bau ihn Szene für Szene, oder lass den Agenten mit einem Rezept einen ganzen Schwung bauen.': 'Create one yourself and build it scene by scene, or let the agent build a whole batch with a recipe.',
  'Neuen Beitrag anlegen': 'Create new post',
  'Erzeuge zuerst die fehlenden Bilder.': 'Create the missing images first.',
  'Neuer Beitrag': 'New post',
  'Anderer Beitrag': 'Other post',
  'Ein Rezept legt fest, wie ein Beitrag aussieht. Hier änderst du nur diesen einen Beitrag; das Rezept bleibt, wie es ist.': 'A recipe defines what a post looks like. Here you only change this one post; the recipe stays as it is.',
  '1 Szene hat kein Bild': '1 scene has no image',
  '{n} Szenen haben kein Bild': '{n} scenes have no image',
  'Ohne Bild lässt sich der Beitrag weder rendern noch freigeben. Wähle die markierte Szene und lass ihr Bild erzeugen.': 'Without an image the post can\'t be rendered or approved. Select the marked scene and have its image created.',
  'Bild fehlt': 'Image missing',
  'Bild erzeugt.': 'Image created.',
  'Bild für Szene {n} erzeugen': 'Create image for scene {n}',
  'Tag entfernen': 'Remove tag',
  'Rezept:': 'Recipe:',
  'klein': 'small',
  'mittel': 'medium',
  'groß': 'large',
  'riesig': 'huge',
  'Reel': 'Reel',
};
